@if (visible()) {
  <div class="loading-overlay" role="status" aria-live="polite">
    <div class="loading-overlay__spinner"></div>
  </div>
}
